/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function postSpin() {
  return remote.post('jackpot_slot');
}

export function getWinners() {
  return remote.get('jackpot_slot/winners');
}
